import React from "react";

function WarningPaymentRulesIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            fill="none"
            viewBox="0 0 32 32"
        >
            <path
                fill="#000"
                fillRule="evenodd"
                d="M16 3.667C9.189 3.667 3.667 9.189 3.667 16c0 6.812 5.522 12.333 12.333 12.333S28.333 22.812 28.333 16C28.333 9.19 22.812 3.667 16 3.667zM1.667 16C1.667 8.084 8.084 1.667 16 1.667S30.333 8.084 30.333 16 23.916 30.333 16 30.333 1.667 23.916 1.667 16zM16 9.667a1 1 0 011 1V16a1 1 0 11-2 0v-5.333a1 1 0 011-1zM16 20a1.333 1.333 0 000 2.667h.013a1.333 1.333 0 000-2.667H16z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
}

export default WarningPaymentRulesIcon;
